import React from "react";
import Navbar from "../components/Navbar";
import Hero from "../components/Hero";
import Services from "../components/Services";
import About from "../components/About";
import Expertise from "../components/Expertise";
import Marquee from "../components/Marquee";
import Stats from "../components/Stats";
import Journey from "../components/Journey";
import Testimonials from "../components/Testimonials";
import Contact from "../components/Contact";
import Footer from "../components/Footer";

export default function Landing() {
  return (
    <div className="bg-white">
      <Navbar />
      <Hero />
      <Services />
      <About />
      <Expertise />
      <Marquee />
      <Stats />
      <Journey />
      <Testimonials />
      <Contact />
      <Footer />
    </div>
  );
}
